module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-fill-plus-73d55f06.svg";